import Head from "next/head";

function HeadWrapper({ canonical, title, desc, keywords }) {
  return (
    <Head>
      {title && <title>{title}</title>}
      
      {/* Viewport Meta Tag */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      
      {/* SEO Meta Tags */}
      {keywords && <meta name="keywords" content={keywords} />}
      {desc && <meta name="description" content={desc} />}
      
      {/* Canonical URL for SEO */}
      {canonical && <link rel="canonical" href={canonical} />}
    </Head>
  );
}

HeadWrapper.displayName = "HeadWrapper"; // ✅ Fixed Typo

export default HeadWrapper;
